import React from 'react'

const User = () => {
  return (
    <svg width="220" height="220" viewBox="0 0 195 195" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M97.1592 16.1875C123.988 16.1877 145.737 37.9369 145.737 64.7656C145.737 80.2402 138.5 94.0229 127.228 102.919C157.054 114.856 178.123 144.025 178.123 178.115H161.93C161.93 142.343 132.931 113.345 97.1592 113.345C61.3872 113.345 32.3887 142.343 32.3887 178.115H16.1953C16.1953 144.026 37.2634 114.858 67.0889 102.92C55.8166 94.0239 48.5811 80.24 48.5811 64.7656C48.5812 37.9369 70.3305 16.1877 97.1592 16.1875ZM97.1592 32.3809C79.2735 32.381 64.7746 46.8799 64.7744 64.7656C64.7744 82.6515 79.2734 97.1512 97.1592 97.1514C115.045 97.1512 129.545 82.6515 129.545 64.7656C129.545 46.8799 115.045 32.381 97.1592 32.3809Z" fill="white" />
    </svg>)
}

export default User